<script setup>
import { computed } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'
import { useSanitizeHtml } from '@/composables/useSanitizeHtml'

const props = defineProps({
  question: {
    type: String,
    required: true
  },
  answer: {
    type: String,
    required: true
  },
  open: {
    type: Boolean,
    default: false
  }
})

const { sanitize } = useSanitizeHtml()
const sanitizedAnswer = computed(() => sanitize(props.answer || ''))
</script>

<template>
  <details class="group" :open="open">
    <summary class="flex items-center justify-between p-6 bg-slate-50 border border-slate-200 rounded-2xl cursor-pointer hover:bg-slate-200 transition-colors list-none">
      <span class="text-lg font-semibold text-text-primary pr-4">{{ question }}</span>
      <div class="w-8 h-8 bg-white rounded-full flex items-center justify-center border border-slate-200 group-open:bg-accent-500 group-open:border-accent-500 transition-all flex-shrink-0">
        <ChevronDownIcon class="w-4 h-4 text-text-tertiary group-open:text-white group-open:rotate-180 transition-all" />
      </div>
    </summary>
    <div class="px-6 pb-6 pt-2 text-text-secondary leading-relaxed">
      <p v-html="sanitizedAnswer"></p>
    </div>
  </details>
</template>

<style scoped>
/* Remove default marker from summary */
summary::-webkit-details-marker {
  display: none;
}
</style>
